import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'iq-nav-bar-logo',
  templateUrl: 'nav-bar-logo.component.html'
})
export class NavBarLogoComponent {
  readonly homeUrl = '/portal';
  constructor(private router: Router) {}

  navigateHome() {
    this.router.navigateByUrl(this.homeUrl);
  }
}
